import { Component, OnInit, ElementRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { DatalayerService } from 'src/services/datalayer.service';
import { TranslateService } from '@ngx-translate/core';
import { ContinuingEducationElement } from 'src/services/hub/continuing-education.interface';
import { HubService } from 'src/services/hub.service';

@Component({
  selector: 'app-continuing-education-panel',
  templateUrl: './continuing-education-panel.component.html',
  styleUrls: ['./continuing-education-panel.component.scss']
})
export class ContinuingEducationPanelComponent implements OnInit {

  eventHtml: SafeHtml | null = null;
  continuingEducationList: ContinuingEducationElement[] = [];

  constructor(
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private datalayerService: DatalayerService,
    private translateService: TranslateService,
    private hubService: HubService
  ) {}

  ngOnInit(): void {
    this.loadMockCourses();
    this.enableClickDelegation();

    this.hubService.fetchContinuingEducation(this.translateService.currentLang).subscribe(list => {
      this.continuingEducationList = [];
  
      list.forEach(item => {
        if (Array.isArray(item.HubElements)) {
          this.continuingEducationList.push(...item.HubElements);
        } else if (item.HubElements) {
          this.continuingEducationList.push(item.HubElements);
        }
      });
    });
  }

  private enableClickDelegation(): void {
    this.elementRef.nativeElement.addEventListener('click', (event: any) => {
      const link = event.target.closest('a[data-coned-link]');
      if (!link) return;

      const linkText = link.getAttribute('data-link-text');
      const linkUrl = link.getAttribute('data-link-url');
      const courseTitle = link.getAttribute('data-course-title');

      this.ConEdClick(linkText, linkUrl, courseTitle);
      window.open(linkUrl, "_blank");
    });
  }

  loadMockCourses() {
    this.http.get('assets/test/courses-mock-data.html', { responseType: 'text' })
      .subscribe({
        next: data => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(data, 'text/html');

          const courseCards = doc.querySelectorAll('.course-card');
          const firstThree = Array.from(courseCards).slice(0, 3);

          const wrapper = document.createElement('div');

          firstThree.forEach(card => {

            const titleEl = card.querySelector('.course-title');
            const courseTitle = titleEl?.textContent?.trim() || '';

            const links = card.querySelectorAll('a');

            links.forEach(link => {
              const linkText = (link.textContent || '').trim();
              const linkUrl = link.getAttribute('href') || '';

              link.setAttribute('data-coned-link', 'true');
              link.setAttribute('data-link-text', linkText);
              link.setAttribute('data-link-url', linkUrl);
              link.setAttribute('data-course-title', courseTitle);

              link.setAttribute('href', 'javascript:void(0)');
            });

            wrapper.appendChild(card);
          });

          this.eventHtml = this.sanitizer.bypassSecurityTrustHtml(wrapper.innerHTML);
        },

        error: err => {
          console.error('Failed to load mock event HTML', err);
        }
      });
  }

  ConEdClick(linkText: string, linkUrl: string, courseTitle: string) {
    this.datalayerService.conEdClick(linkText, linkUrl, courseTitle);
  }

  onViewAllCoursesClick(event: Event): void {
    event.preventDefault();

    const text = this.translateService.instant('Home.viewcourses'); 
    const title = text;
    const link = 'viewmoreplaceholder'; 

    this.ConEdClick(text, link, title);

    window.open(link, "_blank");
  }

  onLearnMoreClick(item: ContinuingEducationElement) {
    const linkText = item.link.text;
    const linkUrl = item.link.href;
    const courseTitle = item.title;
    const cleanTitle = courseTitle.replace(/\\[nt]/g, "").trim();

    this.ConEdClick(linkText, linkUrl, cleanTitle);

    window.open(linkUrl, '_blank');
  }


}
